import type { GatsbyBrowser } from "gatsby";
import "./src/styles/global.css";

function markIOSWebKit() {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isIOS) {
    document.documentElement.setAttribute("data-ios-webkit", "");
  } else {
    document.documentElement.removeAttribute("data-ios-webkit");
  }
}

// gatsby-ssr marks iOS before first paint. Reassert after hydration and route
// transitions as a safeguard; the dedicated data attribute is intentionally
// outside Gatsby Head's managed html attributes.
export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] =
  markIOSWebKit;

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = markIOSWebKit;
